/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { BulkDeleteHpListItemDto, HpBulkDeleteFilterDto } from '@gh/builder-shared-data';

export type BulkDeleteHpFilter = HpBulkDeleteFilterDto;
export type HpBulkDeleteListItem = BulkDeleteHpListItemDto;

export const BULK_DELETE_HP_DEFAULT_FILTER = { days: 180, isQqOnly: true };
